export default function SafetySection() {
  return (
    <section id="bezpieczenstwo" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-800 text-xs font-medium rounded-full mb-4">
            Bezpieczeństwo
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Czy <strong>USFansSpreadsheet</strong> jest bezpieczny?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Twoje bezpieczeństwo jest dla nas priorytetem. Oto dlaczego możesz nam zaufać.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {[
            {
              icon: "ri-shield-check-line",
              title: "Zweryfikowane źródła",
              desc: "Wszystkie dane w USFansSpreadsheet pochodzą ze sprawdzonych i zaufanych źródeł. Każdy arkusz przechodzi wieloetapową weryfikację przed publikacją, co gwarantuje najwyższą jakość i dokładność informacji.",
            },
            {
              icon: "ri-lock-line",
              title: "Szyfrowane połączenie",
              desc: "Korzystamy z najnowszych standardów szyfrowania, aby chronić Twoje dane. USFansSpreadsheet nie zbiera żadnych danych osobowych użytkowników – Twoja prywatność jest w pełni chroniona.",
            },
            {
              icon: "ri-refresh-line",
              title: "Regularne aktualizacje",
              desc: "USFansSpreadsheet jest aktualizowany co tydzień, aby zapewnić najświeższe informacje. Każda aktualizacja obejmuje sprawdzenie cen, dostępności i nowych produktów we wszystkich 14 kategoriach.",
            },
          ].map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-7"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 mb-4">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-xs text-foreground-500">
            Ostatnia aktualizacja: 24 czerwca 2026 &middot; Źródła: oficjalne informacje, analizy branżowe, dane użytkowników
          </p>
        </div>
      </div>
    </section>
  );
}